/*
 * KZK sepet 50 adet sınırı (30.09.2026)
 * Shopify /cart/add.js ve /cart/change.js ile bir varyant sepette en fazla 50 adete çıkabiliyor (51+ istekte 422 "Stok durumu
 * nedeniyle sepetinize yalnızca 50 ürün eklendi"); /cart/update.js bu sınırı uygulamıyor. Bu katman:
 *   - add.js: satırı 50'nin üstüne çıkaracak istekte ilk 50'yi add.js ile ekler (Shopify stok/satış kontrolü yine yapılır),
 *     kalanını update.js ile satır anahtarı üzerinden tamamlar;
 *   - change.js: 50'nin üstündeki adedi update.js ile yazar.
 * Bölme gerekmeyen istek aynen geçer. update.js stok kontrolü yapmadığı için üst sınırı hızlı görünümdeki set sayısı ve
 * sipariş onayındaki stok kontrolü belirler. Diğer sepet betiklerinden ÖNCE (defer'siz) yüklenmelidir.
 */
(function () {
  'use strict';
  if (window.__kzkSepet50) return;
  window.__kzkSepet50 = true;

  var LIMIT = 50;
  var asilFetch = window.fetch.bind(window);
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function yol(input) {
    try { return new URL(typeof input === 'string' ? input : (input && input.url) || '', location.origin).pathname; } catch (e) { return ''; }
  }

  function ozellikAnahtari(props) {
    var o = props && typeof props === 'object' ? props : {};
    return JSON.stringify(Object.keys(o).filter(function (k) { return o[k] !== null && o[k] !== undefined && o[k] !== ''; }).sort().map(function (k) { return [k, String(o[k])]; }));
  }

  function formdanNesne(fd) {
    var o = {};
    fd.forEach(function (deger, ad) {
      if (typeof deger !== 'string') return;
      var m;
      if ((m = /^properties\[(.+)\]$/.exec(ad))) { o.properties = o.properties || {}; o.properties[m[1]] = deger; }
      else if ((m = /^items\[(\d+)\]\[(\w+)\](?:\[(.+)\])?$/.exec(ad))) {
        o.items = o.items || [];
        var it = o.items[+m[1]] = o.items[+m[1]] || {};
        if (m[2] === 'properties' && m[3]) { it.properties = it.properties || {}; it.properties[m[3]] = deger; } else it[m[2]] = deger;
      }
      else o[ad] = deger;
    });
    return o;
  }

  function govdeOku(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      try { return JSON.parse(body); } catch (e) { try { return formdanNesne(new URLSearchParams(body)); } catch (e2) { return null; } }
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) return formdanNesne(body);
    if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) return formdanNesne(body);
    return null;
  }

  function sepetOku() {
    return asilFetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function jsonGonder(adres, govde) {
    return asilFetch(root + adres, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(govde)
    });
  }

  function jsonYanit(nesne) {
    return new Response(JSON.stringify(nesne), { status: 200, headers: { 'Content-Type': 'application/json' } });
  }

  function satirBul(sepet, id, props) {
    var a = ozellikAnahtari(props);
    return (sepet.items || []).find(function (l) { return Number(l.variant_id || l.id) === Number(id) && ozellikAnahtari(l.properties) === a; }) || null;
  }

  function ekle(input, init, veri) {
    var tekli = !Array.isArray(veri.items);
    var items = (tekli ? [{ id: veri.id, quantity: veri.quantity === undefined ? 1 : veri.quantity, properties: veri.properties }] : veri.items)
      .map(function (it) { return { id: Number(it.id), quantity: Math.max(0, parseInt(it.quantity, 10) || 0), properties: it.properties }; })
      .filter(function (it) { return it.id && it.quantity; });
    if (!items.length) return asilFetch(input, init);
    return sepetOku().then(function (sepet) {
      var hedefler = [];
      var eklenecek = [];
      items.forEach(function (it) {
        var mevcut = satirBul(sepet, it.id, it.properties);
        var onceki = mevcut ? Number(mevcut.quantity) || 0 : 0;
        var hedef = onceki + it.quantity;
        var ilk = Math.max(0, Math.min(it.quantity, LIMIT - onceki));
        if (ilk > 0) eklenecek.push({ id: it.id, quantity: ilk, properties: it.properties });
        if (hedef > LIMIT) hedefler.push({ id: it.id, properties: it.properties, hedef: hedef });
      });
      if (!hedefler.length) return asilFetch(input, init);
      var ekAlanlar = {};
      ['sections', 'sections_url'].forEach(function (k) { if (veri[k] !== undefined) ekAlanlar[k] = veri[k]; });
      var adim = eklenecek.length ? jsonGonder('cart/add.js', Object.assign({ items: eklenecek }, ekAlanlar)) : Promise.resolve(null);
      return adim.then(function (r) {
        if (r && !r.ok) return r;
        return sepetOku().then(function (sepet2) {
          var guncelle = {};
          var eksik = false;
          hedefler.forEach(function (h) {
            var satir = satirBul(sepet2, h.id, h.properties);
            if (satir) guncelle[satir.key] = h.hedef; else eksik = true;
          });
          if (eksik) return jsonYanit({ status: 422, message: 'Sepet', description: 'Ürün sepete eklenemedi, lütfen tekrar deneyin.' });
          return jsonGonder('cart/update.js', Object.assign({ updates: guncelle }, ekAlanlar)).then(function (u) {
            if (!u.ok) return u;
            return u.json().then(function (cart) {
              var satirlar = (cart.items || []).filter(function (l) {
                return items.some(function (it) { return Number(l.variant_id) === it.id && ozellikAnahtari(l.properties) === ozellikAnahtari(it.properties); });
              });
              if (tekli) return jsonYanit(Object.assign({}, satirlar[0] || {}, { sections: cart.sections }));
              return jsonYanit({ items: satirlar, sections: cart.sections });
            });
          });
        });
      });
    }).catch(function () { return asilFetch(input, init); });
  }

  function degistir(input, init, veri) {
    var hedef = parseInt(veri.quantity, 10);
    if (!(hedef > LIMIT)) return asilFetch(input, init);
    return sepetOku().then(function (sepet) {
      var items = sepet.items || [];
      var satir = null;
      if (veri.line) satir = items[(parseInt(veri.line, 10) || 0) - 1] || null;
      else if (String(veri.id || '').indexOf(':') !== -1) satir = items.find(function (l) { return l.key === String(veri.id); }) || null;
      else satir = items.find(function (l) { return String(l.variant_id) === String(veri.id); }) || null;
      if (!satir) return asilFetch(input, init);
      var govde = { updates: {} };
      govde.updates[satir.key] = hedef;
      ['sections', 'sections_url'].forEach(function (k) { if (veri[k] !== undefined) govde[k] = veri[k]; });
      return jsonGonder('cart/update.js', govde);
    }).catch(function () { return asilFetch(input, init); });
  }

  window.fetch = function (input, init) {
    try {
      var yontem = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (yontem === 'POST' && init && init.body) {
        var p = yol(input);
        var tur = /\/cart\/add\.js$/.test(p) ? 'add' : /\/cart\/change\.js$/.test(p) ? 'change' : null;
        if (tur) {
          var veri = govdeOku(init.body);
          if (veri) return tur === 'add' ? ekle(input, init, veri) : degistir(input, init, veri);
        }
      }
    } catch (e) { /* hata olursa istek değiştirilmeden gider */ }
    return asilFetch(input, init);
  };
})();
